

class SubscriptionSelector {
  constructor(selectId,baseURL) {
    this.selectElement = document.getElementById(selectId);
    this.revealOriginEle = document.getElementById("hide-profile-names");
    this.baseURL = baseURL||"";
    if (!this.selectElement) {
      console.warn(`Element with id "${selectId}" not found`);
      return;
    }


    this.customerEmail = document.getElementById("customerEmail").value;
    this.init();
  }

  async init() {
    try {
      showLoader();
      const subscriptions = await this.fetchSubscriptionList();
      this.populateSelect(subscriptions);
      this.attachChangeHandler();
    } catch (error) {
      console.log("Error initializing subscription selector:", error);
    }finally{
      hideLoader();
    }
  }

  async fetchSubscriptionList() {
    try {
      // Replace this with your actual API call
    const response = await fetch(`${this.baseURL}/api/get-subscription-list`,{
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body:JSON.stringify({
            queries:[
                {
                    key:"customerEmail",
                    value:this.customerEmail
                }
            ]
        })
    });
    if (!response.ok) throw new Error("Failed to fetch subscriptions");

    const data = await response.json();
    return data.data.subscriptionList;
    } catch (error) {
      throw error;
    }
  };

  populateSelect(subscriptions) {
    this.selectElement.innerHTML = `<option value="">Select a subscription</option>`;

    subscriptions.forEach((sub) => {
      const option = document.createElement("option");
      option.value = sub.conId;
      option.textContent = `#${sub.conId}`;
      this.selectElement.appendChild(option);
    });
  }

  attachChangeHandler() {
    this.selectElement.addEventListener("change", (event) => {
      const selectedId = event.target.value;
      if (selectedId) {
        this.handleSubscriptionSelect(selectedId);
        this.selectedSubId = selectedId;
      }
    });

    this.revealOriginEle.addEventListener("change",(event)=>{
      this.updateProfileNameOnCheckUnCheck(event);
    });
  }

  async handleSubscriptionSelect(subscriptionId) {
    showLoader();
    try {
      const response = await fetch(`${this.baseURL}/api/get-taste-profile-list`,{
        method:"POST",
        headers: {
            "Content-Type": "application/json"
        },
        body:JSON.stringify({
          subsId:subscriptionId
        })
      });
      if (!response.ok) throw new Error("Failed to perform action");

      const result = await response.json();


      const newData = result.data.groupWiseTasteProfile.map(group => {
        let orderCounter = 0;
        group.tasteProfiles = group.tasteProfiles.map(profile => {
          if (profile.selected) {
            // assign order based on appearance in API response
            profile.clickedAt = ++orderCounter;
          }
          return profile;
        });
        return group;
      });

      console.log(newData);


      const {groupWiseTasteProfile,...rest} = result.data;
      
      this.groupWiseTasteProfile = groupWiseTasteProfile;
      this.restData = rest;

      // this._currentGroupName = result.data._currentGroupName;
      // this._productId = result.data._productId;

      this.populateTasteProfileDetails(result.data.groupWiseTasteProfile);

      if(this.revealOriginEle?.disabled){
        this.revealOriginEle.disabled = false;
      }
    } catch (error) {
      console.error("Error handling selection:", error);
    }finally{
      hideLoader();
    }
  }

  populateTasteProfileDetails(){
    const wrapper = document.getElementById("coffee-taste-wrapper");

    wrapper.innerHTML = "";

    const tasteProfileList=[]
    
    this.groupWiseTasteProfile?.forEach(group => {
      group?.tasteProfiles?.forEach(tProfile => {
        tasteProfileList.push({...tProfile,group:{...group}})
      });
    });

    const shortedTasteProfile = tasteProfileList.sort((a, b) => Number(a.preferences) - Number(b.preferences));

    // console.log("populating taste profile");
    // console.log(tasteProfileList);


    shortedTasteProfile.forEach(({group,...profile})=>{
      const tasteProfileNode = `
        <div class="profile-card">
            <label class="profile-toggle">
            <input 
                type="checkbox" 
                class="profile-input" 
                id="toggle-${group.handle}-${profile.name?.replaceAll(" ","")}"
                name="toggle-${profile.name}"
                ${profile.selected ? 'checked' : ''} 
            >
            <div class="profile-info">
                <span class="toggle-slider"></span>
                <span class="profile-name ${profile.colourCode?.toLowerCase()}">${profile.colourCode}</span>
            </div>
            <span class="profile-description" style="display: none;">
                <strong style="text-transform: uppercase;">${profile.name} PROFILE</strong> / ${profile.description}
            </span>
            </label>
        </div>
      `;
      const template = document.createElement("template");
      template.innerHTML = tasteProfileNode.trim();
      wrapper.appendChild(template.content.firstChild);

      const inputEl = wrapper.querySelector(`#toggle-${group.handle}-${profile.name?.replaceAll(" ","")}`);
      if (inputEl) {
        inputEl.addEventListener('change', (event) => {
            this.handleOnChangeTasteProfile(event,group.handle,profile);
        });
      }
    });

    // this.groupWiseTasteProfile?.forEach((group,index) => {

    //     group?.tasteProfiles?.forEach((profile,idx)=>{
    //         const tasteProfileNode = `
    //             <div class="profile-card">
    //                 <label class="profile-toggle">
    //                 <input 
    //                     type="checkbox" 
    //                     class="profile-input" 
    //                     id="toggle-${group.handle}-${profile.name?.replaceAll(" ","")}"
    //                     name="toggle-${profile.name}"
    //                     ${profile.selected ? 'checked' : ''} 
    //                 >
    //                 <div class="profile-info">
    //                     <span class="toggle-slider"></span>
    //                     <span class="profile-name ${profile.colourCode?.toLowerCase()}">${profile.colourCode}</span>
    //                 </div>
    //                 <span class="profile-description" style="display: none;">
    //                     <strong style="text-transform: uppercase;">${profile.name} PROFILE</strong> / ${profile.description}
    //                 </span>
    //                 </label>
    //             </div>
    //         `;
    //         const template = document.createElement("template");
    //         template.innerHTML = tasteProfileNode.trim();
    //         wrapper.appendChild(template.content.firstChild);

    //         const inputEl = wrapper.querySelector(`#toggle-${group.handle}-${profile.name?.replaceAll(" ","")}`);
    //         if (inputEl) {
    //         inputEl.addEventListener('change', (event) => {
    //             this.handleOnChangeTasteProfile(event,group.handle,profile);
    //         });
    //         }
    //     });
    // });
  };

  handleOnChangeTasteProfile(e,groupName,profile){
    
    this.groupWiseTasteProfile = this.groupWiseTasteProfile.map((group)=>{
      if(group.handle === groupName){
        group.tasteProfiles = group.tasteProfiles?.map((tProfile)=>{
          if(tProfile.name === profile.name){
            // tProfile.selected = e.target.checked
            if (e.target.checked) {
              tProfile.selected = true;
              tProfile.clickedAt = Date.now(); // 🔑 track click time
            } else {
              tProfile.selected = false;
              delete tProfile.clickedAt;
            }
          };
          return tProfile;
        });
      };
      return group;
    });

    this.handleUpdateTasteProfile();
  };


  async handleUpdateTasteProfile(){
    showLoader();
    try {
      const dataToBeUpload = {};
      this.groupWiseTasteProfile?.map((group)=>{
        // const selectedProfiles = group.tasteProfiles?.filter((profile) => !!profile?.selected).sort((a, b) => a.clickedAt - b.clickedAt);
        const selectedProfiles = group.tasteProfiles?.filter((profile) => !!profile?.selected);



        // tastes:group.tasteProfiles?.filter((profile)=>!!profile?.selected).map((profile)=>{
        //   return{
        //     taste:profile.name,
        //   }
        // })

        dataToBeUpload[group.handle] = {
          currentIndex:group.currentIndex,
          // lastTaste:group.lastTaste,
          tastes:selectedProfiles.map((profile) => ({
            taste: profile.name,
          }))
        }
      });

      console.log(dataToBeUpload);

      if(dataToBeUpload?.[this.restData._currentGroupName]?.tastes?.length <= 0) {
        Object.keys(dataToBeUpload).forEach((key)=>{
          if(dataToBeUpload?.[key]?.tastes?.length > 0){
            this.restData._currentGroupName = key;
          }
        });
      }

      const response = await fetch(`${this.baseURL}/api/update-customAttributes`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          subId: this.selectedSubId,
          subCustomAttributes:{
            ...this.restData,
            _selected_taste:dataToBeUpload,
            _selectionType:true,
            // _currentGroupName:this._currentGroupName,
            // _productId:this._productId
          }
        })
      });

      if (!response.ok) throw new Error("Failed to update");
      
    } catch (error) {
      console.log(error);
    }finally{
      hideLoader();
    }
  }

  updateProfileNameOnCheckUnCheck(e){
    const status = this.revealOriginEle.checked;

    const allProfileTitle = document.querySelectorAll(".profile-card");

    allProfileTitle.forEach(function(item){
      const profileDetailsNode = item.querySelector(".profile-description");
        if (profileDetailsNode) {
            if (status) {
                profileDetailsNode.style.display = "inline"; // or "block"
            } else {
                profileDetailsNode.style.display = "none";
            }
        }
    });
  }
}

document.addEventListener("DOMContentLoaded", () => {

  // const currentURL = window.location.href;
  // let baseURL = "";

  // if(currentURL.includes("ckdriftdev")){
  //   baseURL = "https://dev.driftaway.coffee";
  // }else if(currentURL.includes("driftdev-2")){
  //   baseURL = "https://stage.driftaway.coffee"
  // }else{
  //   baseURL = "https://prod.driftaway.coffee"
  // };
  new SubscriptionSelector("subscription-select",baseURL);
});
